import React, { Component, Fragment } from 'react';

class CCLCheckbox extends Component {
  render () {
    const { useWrap } = this.props;

    if (useWrap) {
      return (
        <div className={'wrap_inp'}>
          {this.renderItem()}
        </div>
      );
    } else {
      return this.renderItem();
    }
  }

  renderItem () {
    const { prefix, item, value, onChange } = this.props;
    return (
      <div key={item.value} className="inp_item">
        <label htmlFor={`${prefix}${item.value}`} className="form-field">
          <input
            type="radio" id={`${prefix}${item.value}`}
            className="form-radio klink-linknew"
            checked={value == item.value}
            onChange={e => onChange(item.value)}
          />
          <span className="checkbox-text">{item.label}</span>
        </label>
      </div>
    );
  }
}

export default CCLCheckbox;
